import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';

const HEALTH_VIEWS = [
    { id: 'stalled', label: 'Stalled', description: 'Loans with no recent movement' },
    { id: 'aging', label: 'Aging', description: 'Loans sitting too long in process' },
    { id: 'at_risk', label: 'At Risk', description: 'Loans showing warning signs' },
    { id: 'cancelled', label: 'Cancelled', description: 'Cancelled or withdrawn loans' },
];

function getHealthCounts(data = []) {
    if (!Array.isArray(data)) {
        return {
            stalled: 0,
            aging: 0,
            at_risk: 0,
            cancelled: 0,
        };
    }

    return {
        stalled: data.filter((loan) => loan.healthStatus === 'stalled').length,
        aging: data.filter((loan) => loan.healthStatus === 'aging').length,
        at_risk: data.filter((loan) => loan.healthStatus === 'at_risk').length,
        cancelled: data.filter((loan) => loan.healthStatus === 'cancelled').length,
    };
}

export default function PipelineHealthHeader({
    filters = {},
    setFilters,
    data = [],
}) {
    const activeView = filters.healthView || 'stalled';
    const counts = getHealthCounts(data);

    const handleSelectView = (viewId) => {
        setFilters((prev) => ({
            ...prev,
            healthView: viewId,
        }));
    };

    return (
        <>
            <Row className="g-3 mb-3">
                {HEALTH_VIEWS.map((view) => {
                    const isActive = activeView === view.id;

                    return (
                        <Col xs={12} sm={6} xl={3} key={view.id}>
                            <Card
                                onClick={() => handleSelectView(view.id)}
                                className={`h-100 ${isActive ? 'border-primary shadow-sm' : ''}`}
                                style={{ cursor: 'pointer' }}
                            >
                                <Card.Body className="py-3">
                                    <div className="d-flex justify-content-between align-items-start">
                                        <div>
                                            <div className="fw-semibold">{view.label}</div>
                                            <div className="text-muted small mt-1">
                                                {view.description}
                                            </div>
                                        </div>
                                        <div className="fs-5 fw-bold">
                                            {counts[view.id] ?? 0}
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    );
                })}
            </Row>

            <Row className="mb-2">
                <Col>
                    <Nav
                        variant="tabs"
                        activeKey={activeView}
                        onSelect={(eventKey) => {
                            if (eventKey) {
                                handleSelectView(eventKey);
                            }
                        }}
                    >
                        {HEALTH_VIEWS.map((view) => (
                            <Nav.Item key={view.id}>
                                <Nav.Link eventKey={view.id}>{view.label}</Nav.Link>
                            </Nav.Item>
                        ))}
                    </Nav>
                </Col>
            </Row>
        </>
    );
}